export default __webpack_public_path__ + "static/media/discord.863cc351.svg";